import {PropsWithChildren} from 'react';
import {Grid} from '../../../design-system/atoms/Grid/Grid';
import {DayOfWeekSectionCardItem} from './DayOfWeekSectionCardItem';

interface Props {
  className?: string;
}

export const DayOfWeekSectionSingleCategory = ({
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <Grid cols={3} foldableCols={6} gapPx={4} className={className}>
      {children}
    </Grid>
  );
};

DayOfWeekSectionSingleCategory.Item = DayOfWeekSectionCardItem;
